import { AxiosError } from "axios";
import { HTTPCode } from "../valueObjects/HTTPCodes";
import { BaseError } from "./BaseError";

type HTTPErrorResponseData = {
  code?: string;
  message?: string;
};

export class HTTPError extends BaseError {
  private httpCode: HTTPCode;
  constructor(reason: string, code: HTTPCode, errorCode?: string) {
    super(reason, errorCode);
    this.httpCode = code;
  }

  static fromAxiosError(error: AxiosError) {
    if (!error.response) {
      return new HTTPError(error.message, new HTTPCode(-1));
    }

    const responseData = error.response.data as HTTPErrorResponseData | undefined;
    const reason = responseData?.message ?? error.message;
    const errorCode = responseData?.code;

    return new HTTPError(reason, new HTTPCode(error.response.status), errorCode);
  }

  public getHTTPCode() {
    return this.httpCode;
  }
}
